import { lazy } from 'react';

export const LinkWallet = lazy(() => import('./LinkWallet.component'));
